export function stepWithin(index, step, max) {
  const pos = (index + step) % max
  return {
    turn: Math.abs(pos > -1 ? pos : max + pos),
    roundModifier: Math.floor((index + step) / max),
  }
}

export default {
  namespaced: true,

  state: {
    name: ``,
  },

  getters: {
    turn: (state, getters, { battle }) =>
      (battle.meta && battle.meta.turn) || 0,
  },

  actions: {
    next: ({ dispatch }) => dispatch(`changeTurn`),
    prev: ({ dispatch }) => dispatch(`changeTurn`, -1),

    changeTurn: (
      {
        dispatch,
        getters: { turn: fromTurn },
        rootGetters: {
          [`battles/battle`]: id,
          [`battle/orderedCombatants`]: combatants,
        },
      },
      step = 1
    ) => {
      const { turn, roundModifier } = stepWithin(
        fromTurn,
        step,
        combatants.length
      )
      const posRoundModifier = Math.abs(roundModifier)

      const roundAction =
        posRoundModifier === roundModifier ? `increment` : `decrement`

      for (let i = 0; i < Math.abs(roundModifier); i++) {
        dispatch(`battle/rounds/${roundAction}`, null, { root: true })
      }

      return dispatch(`battle/update`, { id, turn }, { root: true })
    },

    reset: ({ dispatch, rootGetters: { [`battles/battle`]: id } }) => {
      return dispatch(`battle/update`, { id, turn: 0 }, { root: true })
    },
  },

  mutations: {
    setName: (state, payload) => {
      return (state.name = payload)
    },
  },
}
